import './App.css';

import { ErrorBoundary } from '@sentry/react';
import React, { lazy } from 'react';
import ReactGA from 'react-ga';
import { useRecoilValue } from 'recoil';

import OverlaySimple from './components/Loading/OverlaySimple';
import { useAuth } from './context/auth';
import useCheckLogin from './hooks/useCheckLogin';
import ErrorPage from './pages/ErrorPage';
import isUserLoadingState from './state/common/atoms/isUserLoadingState';

const Login = lazy(() => import('./pages/Login'));
const Router = lazy(() => import('./Router'));

const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID || null;
ReactGA.initialize(GA_TRACKING_ID);

function App() {
    const { isLoggedIn } = useAuth();
    const isUserLoading = useRecoilValue(isUserLoadingState);

    useCheckLogin();

    const render = () => {
        // until we have check whether the user is logged in, show nothing other than a loading screen
        // otherwise we needlessly load & render the Login or Router
        if (isUserLoading) {
            return <OverlaySimple />;
        }
        if (isLoggedIn) {
            return <Router />;
        }
        return <Login />;
    };

    return <ErrorBoundary fallback={<ErrorPage />}>{render()}</ErrorBoundary>;
}

export default App;
